"use client";

import {useEffect} from "react";
import {useCampusContext} from "./contexts/CampusCookieContext";

/**
 * This component is a workaround for NextJS limitations around cookies.
 *
 * Cookies cannot be set in server components - see https://github.com/vercel/next.js/discussions/49843
 * for a long discussion of this.
 *
 * To get around this, we define a client component which just sets the campus cookie,
 * and can be rendered as a child of a server component.
 *
 * We could make this more generic and use it for arbitrary cookies, but honestly
 * I'd prefer to discourage using this pattern for things other than the campus.
 */
const CampusCookieSetter: React.FC<{campusId: string}> = ({campusId}) => {
	const {setCampus} = useCampusContext();
	useEffect(() => {
		setCampus(campusId);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return null;
};

export default CampusCookieSetter;
